import { registerCpProductType } from '@bcf-vanilla-ts-v1-api-access/config-tokens/env-cp';
import { registerDiToken } from '@bcf-vanilla-ts-v1-shared/di/di-token';
import { APP_HOSTNAME } from '@bcf2-v1-configurators-tokens/app/token';
import { releaseVersion } from '@bcflit-release-version';
import { LOCAL_STORAGE, LOCATION, SESSION_STORAGE } from '@bcflit-v1-configurators/tokens/app/token';
import { registerBcf2ModalAdapters } from '@bcflit-v1-ui-modals-shared/register-bcf2-modal-adapters';
import { registerBcf2RouterAdapters } from '@bcflit-v1-ui-shared/router/register-bcf2-router-adapters';
import { setReleaseVersion } from '@tmf-ui-shared/misc/set-release-version';

export function registerAppProviders(): void {
  registerCpProductType('sportsbook');
  registerBcf2RouterAdapters();
  registerBcf2ModalAdapters();
  setReleaseVersion(releaseVersion, document);
  registerDiToken(APP_HOSTNAME, () => document.location.hostname);
  registerDiToken(LOCAL_STORAGE, () => localStorage);
  registerDiToken(SESSION_STORAGE, () => sessionStorage);
  registerDiToken(LOCATION, () => location);
}
